import React from "react";
import { useTheme } from "../../../hooks/useTheme.js";

// Shared "Step N of M / title / description" block for the redesigned steps.
const StepHeader = ({ stepNumber, totalSteps, title, description }) => {
  const { theme } = useTheme();
  const isLight = theme === "light";

  return (
    <div>
      {stepNumber != null && totalSteps > 0 && (
        <p
          className={`italic text-[13px] mb-1.5 ${
            isLight ? "text-slate-400" : "text-gray-500"
          }`}
        >
          Step {stepNumber} of {totalSteps}
        </p>
      )}

      {/* text-left is explicit: a global `h1 { text-align: center }` in
          HRPortal.css leaks into every page and would centre this heading. */}
      <h1
        className={`text-left text-[22px] font-medium leading-snug mb-2 ${
          isLight ? "text-slate-900" : "text-white"
        }`}
      >
        {title}
      </h1>

      {description && (
        <p
          className={`text-[14px] leading-relaxed max-w-[560px] ${
            isLight ? "text-slate-500" : "text-gray-400"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default StepHeader;
